import {categoriesContentType, titlesContentType, descriptionsContentType} from "../types"

const CATEGORIES: categoriesContentType = [
    {
        key: 'youtube',
        description: 'For YouTube banner'
    },
    {
        key: 'facebook',
        description: 'For Facebook'
    },
    {
        key: 'twitter',
        description: 'For Twitter'
    },
    {
        key: 'instagram',
        description: 'For Instagram'
    },
    {
        key: 'linkedin',
        description: 'For LinkedIn'
    },
    {
        key: 'google',
        description: 'For Google Banner Ads'
    }
];

const TITLES = {
    rotate: {
        
            facebook: `Rotate Image for Facebook`,
            youtube: `Rotate Image for YouTube`,
            instagram: `Rotate Image for Instagram`,
            twitter: `Rotate Image for Twitter`,
            linkedin: `Rotate Image for LinkedIn`,
            google: `Rotate Image for Google Ads`
        
    },
    resizer: {
        facebook: ``,
        youtube: ``,
        instagram: ``,
        twitter: ``,
        linkedin: ``,
        google: ``
    },
    flipper: {
        facebook: `Flip Image for Facebook`,
        youtube: `Flip Image for YouTube`,
        instagram: `Flip Image for Instagram`,
        twitter: `Flip Image for Twitter`,
        linkedin: `Flip Image for LinkedIn`,
        google: `Flip Image for Google Ads`
    },

    cropper: {
        facebook: `Crop Image for Facebook`,
        youtube: `Crop Image for YouTube`,
        instagram: `Crop Image for Instagram`,
        twitter: `Crop Image for Twitter`,
        linkedin: `Crop Image for LinkedIn`,
        google: `Crop Image for Google Ads`
    },

    default: {
        
        facebook: ``,
        youtube: ``,
        instagram: ``,
        twitter: ``,
        linkedin: ``,
        google: ``
    
    }
};

const DESCRIPTIONS = {
    rotate: {
       facebook: 
            `Rotate image online to use it on Facebook. All Fb photo types are supported: profile pic, cover, stories, 
            ads, etc. You can upload a picture in any format: jpg, gif, png, bmp, and others. `,
    
        youtube: 
            `Use Image Rotator to rotate your images for YouTube channel. With our image editor, you can prepare 
            pics for YouTube banners, profile, cover, thumbnail,s and other goals. Just upload an image with the 
            wrong orientation and rotate it in 2 clicks.`,
        
        instagram: 
            `Rotate an image for your Instagram profile. You can rotate photo for Instagram stories, profile pic,
             reels, profiles, and so on. Just select the desired option from the menu below. `,
    
        twitter: 
            `Rotate the image clockwise or to a custom angle for your Twitter page. Use one of the ready presets to 
            rotate pictures to a necessary angle. Save the rotated photos on your device and upload them to Twitter.`,
    
        linkedin: 
            `Image rotation tool can rotate image files for LinkedIn page. To prepare photos for LinkedIn, upload 
            them to our tool and select if you want to rotate files clockwise or anticlockwise. Don't forget to 
            download the rotated images.`,
    
        google: 
            `Free Image Rotator is a perfect tool to rotate files for Google Ads campaign. It will keep the quality of 
            your images and can rotate them to any angle. With our tool, you can let your creativity flow without 
            thinking about difficult software. `
        
    },

    resizer: {
        facebook: 
            `Resize photos and images for Facebook. Customize image for any Facebook size: 
            profile photo, cover, story, posts, or events. Upload photos and images from your computer to free Image Resizer, 
            choose the necessary size, and the service will do the rest of the work for you. If necessary, 
            edit, flip or rotate uploaded images. Download ready photos in a new image resolution.`,

        youtube: 
            `Create high-quality images for your YouTube channel. Resize images for YouTube video thumbnail, channel cover, 
            or profile photo. Image resize tool can easily change width and height to fit your goals. You don't 
            need to spend much time and learn how to use tricky software. Simply add photos into the service and 
            it will do the job for you in seconds.`,
      
      
        instagram: 
            `Upload horizontal pictures, portrait, square, or other images for resizing. Free Online Image Resizer will resize 
            your images without losing image quality or colors. Change image size for Instagram stories, ads, posts. 
            Apply filters to get more likes.`,
      
        twitter:
            `With Free Image Resizer, you can also resize and edit your images and pictures for Twitter pretty fast. 
            Add image from computer or smartphone in any format: jpg, png, jpeg, bmp. Change image aspect ratio, dimensions (width and height), 
            image file size.  Drag and drop photos into the service. Then use free options like crop, flip or rotate 
            if you need to edit your photos.`,

      linkedin:
            `Change image width and height to fit your LinkedIn page. You can add and resize as many images online 
            as you wish. The image resizing tool will automatically resize your photo or image in seconds. You simply 
            need to upload your images and select a resizing option.`,
  
      google:
        `Resize images for your Google Ads campaign. Prepare high-quality banners and thumbnails for your blog posts. 
        Paste the ready image where you want it to be on your site. Optimize and resize images for your blog or web page. 
        Reduce image size for easy posting.`,
    },

    flipper: {
        facebook: 
            `Flip image horizontally or vertically to use it on your Facebook page.  
            You can flip picture for Fb profile pic, cover, stories, banners, etc. 
            All formats are supported: jpg, gif, png, bmp, and others.`,
        
        youtube: 
            `Use Image Flipper to mirror images for YouTube channel. With our image flip web 
            app, you can edit pictures for YouTube profile, cover, thumbnails, banners. `,
        
            instagram: 
            `Mirror an image for Instagram profile pic, stories, reels, ads. 
            Upload a photo that you want to mirror and select a ready preset to flip the image for Instagram. `,
        
        twitter: 
            `Mirror an image for your Twitter account page. Create great pics for your social network page. 
            Flip image for Twitter profile pic, background, post, ads, etc. 
            Download the flipped image and use it on Twitter.`,

        linkedin: 
            `Use image flip service for your LinkedIn page. Choose photos that you want to flip for 
            LinkedIn and drag-n-drop them to this page. Then choose LinkedIn among options and 
            click "OK" to get the job done.`,

        google: 
            `Free Image Flipper is a perfect solution to mirror files for Google Ads tasks. 
            With our web app, you can easily flip any image, no matter its size or resolution. 
            You will only need to save a ready picture on your device.`
    },

    cropper: {
        facebook: 
            `With Online Image Cropper, you can easily crop photo for your Facebook profile. 
            You don't need to look for the necessary file resolution. 
            Use one of the ready options for Facebook, and the tool will edit the images for you.`,
        
        youtube: 
            `Online image cropping tool will help you prepare images for your YouTube profile. 
            Upload your photo and choose whether you want to cut an image for a YouTube profile, 
            YouTube cover, or one of the YT ads resolutions. 
            Then click the Crop button and let the service do the rest for you.`,
        
        instagram: 
            `Crop image online for uploading to Instagram. 
            You can either choose one of the ready presets or set the cropping parameters manually. 
            Don't forget to download the ready file on your PC or smartphone.`,
        
        twitter: 
            `Online Image Cropper provides a number of ready presets for Twitter images. 
            You don't need to install difficult software to crop your images. 
            Just upload your pics to our service and get the job done in literally two clicks.`,

        linkedin: 
            `Crop your images for LinkedIn in a couple of clicks. 
            You simply need to upload a file that you want to cut and select whether you want 
            to crop it for a LinkedIn profile pic, cover, ad, or any other purpose.`,

        google: 
            `Use Online Image Cropping tool to prepare images for your Google Ads campaign. 
            We collected the most popular image sizes used in Google Ads. 
            You only need to select the desired resolution, and the service will edit the pic for you.`
    },

    default: {
        facebook: ``,
        youtube: ``,
        instagram: ``,
        twitter: ``,
        linkedin: ``,
        google: ``
    },
};

export default function categoriesContent(service: string): 
{categories: categoriesContentType, titles: titlesContentType, descriptions: descriptionsContentType} {
    return {
        categories: CATEGORIES,
        titles: Object.keys(TITLES).includes(service) ? TITLES[service] : TITLES.default,
        descriptions: Object.keys(DESCRIPTIONS).includes(service) ? DESCRIPTIONS[service] : DESCRIPTIONS.default
    }

}